// extracted by mini-css-extract-plugin
module.exports = {"opLayout":"Layout-module__opLayout___2jYjc","content":"Layout-module__content___2eUHp"};